import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import { Navigate } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import AuthenticationRoutes from './AuthenticationRoutes';
// import Expenses from 'views/pages/Expenses';

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/dashboard')));

// pages routing

// quotations
const AllQuotations = Loadable(
  lazy(() => import('views/pages/Quotations/AllQuotations'))
);
const NewQuotations = Loadable(
  lazy(() => import('views/pages/Quotations/NewQuotations'))
);
const SentToClient = Loadable(
  lazy(() => import('views/pages/Quotations/SentToClient'))
);
const AcceptedQuotations = Loadable(
  lazy(() => import('views/pages/Quotations/AcceptedQuotations'))
);
const DeclinedQuotations = Loadable(
  lazy(() => import('views/pages/Quotations/DeclinedQuotations'))
);
const AnalyzeDeclined = Loadable(
  lazy(() => import('views/pages/Quotations/AnalyzeDeclined'))
);

// product management
const ProductList = Loadable(
  lazy(() => import('views/pages/ProductManagement/ProductList'))
);
const DiscontinuedProducts = Loadable(
  lazy(() => import('views/pages/ProductManagement/DiscontinuedProducts'))
);
const Uom = Loadable(lazy(() => import('views/pages/ProductManagement/Uom')));

// client management
const ClientList = Loadable(
  lazy(() => import('views/pages/ClientManagement/ClientList'))
);
const InactiveClient = Loadable(
  lazy(() => import('views/pages/ClientManagement/InactiveClient'))
);

// profile
const Profile = Loadable(lazy(() => import('views/pages/Profile')));
const MyInfo = Loadable(lazy(() => import('views/pages/Profile/MyInfo')));
const CompanyInfo = Loadable(
  lazy(() => import('views/pages/Profile/CompanyInfo'))
);

// utilities routing

// setting routing
const CompanyList = Loadable(lazy(() => import('views/setting/CompanyList')));
const ManageUser = Loadable(lazy(() => import('views/setting/ManageUser')));
const SingleUser = Loadable(
  lazy(() => import('views/setting/ManageUser/SingleUser'))
);
const UserInfo = Loadable(
  lazy(() => import('views/setting/ManageUser/SingleUser/UserInfo'))
);
const UserPermission = Loadable(
  lazy(() => import('views/setting/ManageUser/SingleUser/UserPermission'))
);

// support routing
const Support = Loadable(lazy(() => import('views/support')));

// Support error routing
const Error404 = Loadable(lazy(() => import('views/Error404')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: <PrivateRoute />,
  children: [
    {
      path: '/',
      element: <MainLayout />,
      children: [
        {
          path: '/',
          element: <Navigate to="dashboard" replace={true} />,
        },
        {
          path: 'dashboard',
          element: <Navigate to="default" replace={true} />,
        },
        {
          path: 'dashboard/default',
          element: <DashboardDefault />,
        },
        {
          path: 'pages',
          children: [
            {
              path: 'quotations',
              children: [
                {
                  path: 'all-quotations',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['all-quotations']}
                    >
                      <AllQuotations />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'new-quotations',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['new-quotations']}
                    >
                      <NewQuotations />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'sent-to-client',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['sent-to-client']}
                    >
                      <SentToClient />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'accepted',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['sent-to-client']}
                    >
                      <AcceptedQuotations />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'declined',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['sent-to-client']}
                    >
                      <DeclinedQuotations />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'analyze-declined',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['analyze-declined']}
                    >
                      <AnalyzeDeclined />
                    </AuthenticationRoutes>
                  ),
                },
              ],
            },
            {
              path: 'product-management',
              children: [
                {
                  path: 'product-list',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['product-list']}
                    >
                      <ProductList />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'discontinued-products',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['discontinued-products']}
                    >
                      <DiscontinuedProducts />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'uom',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['uom']}
                    >
                      <Uom />
                    </AuthenticationRoutes>
                  ),
                },
              ],
            },
            {
              path: 'client-management',
              children: [
                {
                  path: 'client-list',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['client-list']}
                    >
                      <ClientList />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'inactivated-clients',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['inactivated-clients']}
                    >
                      <InactiveClient />
                    </AuthenticationRoutes>
                  ),
                },
              ],
            },
            {
              path: 'profile',
              element: <Profile />,
              children: [
                {
                  path: '',
                  element: <MyInfo />,
                },
                {
                  path: 'company-info',
                  element: <CompanyInfo />,
                },
              ],
            },
          ],
        },
        {
          path: 'utils',
          children: [
            {
              path: 'setting',
              children: [
                {
                  path: 'company',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['company']}
                    >
                      <CompanyList />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'manage-user',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['manage-user']}
                    >
                      <ManageUser />
                    </AuthenticationRoutes>
                  ),
                },
                {
                  path: 'manage-user/:id',
                  element: (
                    <AuthenticationRoutes
                      allowedRoles={['super_admin', 'admin']}
                      allowedCodes={['manage-user']}
                    >
                      <SingleUser />
                    </AuthenticationRoutes>
                  ),
                  children: [
                    {
                      path: '',
                      element: <UserInfo />,
                    },
                    {
                      path: 'permission',
                      element: <UserPermission />,
                    },
                  ],
                },
              ],
            },
            {
              path: 'support',
              element: <Support />,
            },
          ],
        },
        {
          path: '/*',
          element: <Error404 />,
        },
      ],
    },
  ],
};

export default MainRoutes;
